import * as React from "react";
const SvgFiRrSaltShaker = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21.908 17.507 20 7.901V6c0-6-5.606-6-8-6S4 0 4 6v1.901l-1.924 9.686A5.49 5.49 0 0 0 3.3 22.051 5.49 5.49 0 0 0 7.5 23.999h8.999a5.49 5.49 0 0 0 4.22-1.973 5.5 5.5 0 0 0 1.189-4.521zM9 2.253V3a1 1 0 0 0 2 0v-.977a23 23 0 0 1 2 0V3a1 1 0 0 0 2 0v-.747c2.16.461 3 1.597 3 3.747v1H6V6c0-2.15.839-3.286 3-3.747m10.184 18.491a3.5 3.5 0 0 1-2.686 1.255H7.5a3.5 3.5 0 0 1-2.672-1.24 3.48 3.48 0 0 1-.784-2.812L5.82 8.999h12.358l1.764 8.879a3.49 3.49 0 0 1-.76 2.866M14 18.499a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3 .001m3-4a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3 .001"
    />
  </svg>
);
export default SvgFiRrSaltShaker;
